export default __webpack_public_path__ + "static/media/billlfy__paymentScreen_sucess.98aca01e.mp4";